import InstantBookingPhotographerFilterForm from '../components/instantBookingPhotographerFilterForm/';
import PhotographerUserRequestLocation from '../components/userRequestLocation/';

const SELECTOR = {
  filterForm: 'aside .form-photographer-filter',
  userRequestLocation: '.user-request-location'
};

class InstantBookingPhotographerScreen {
  constructor() {
    this._setup();
  }

  // Private Methods

  _setup() {
    const filterForm = document.querySelector(SELECTOR['filterForm']);
    const userRequestLocation = document.querySelector(SELECTOR['userRequestLocation']);

    filterForm && new InstantBookingPhotographerFilterForm(filterForm);
    userRequestLocation && new PhotographerUserRequestLocation(userRequestLocation);
  }
}

// Setup the InstantBookingPhotographerScreen class, only on the photographers page.
let isInstantBookingPhotographerPage = document.body.classList.contains('instant-booking-photographers') && document.body.classList.contains('index');

if (isInstantBookingPhotographerPage) {
  new InstantBookingPhotographerScreen();
}
